module.exports = __webpack_public_path__ + "img/home_productfour.e84af84e.jpg";